import { lazy } from 'react';
import Loadable from 'ui-component/Loadable';
import type { RouteObject } from 'react-router-dom';

const DashboardPage = Loadable(lazy(() => import('./components/DashboardPage')));

/**
 * This feature's own routes, composed into the app router by whichever legacy route file
 * still owns this path prefix — src/routes/AuthenticatedRoutes.jsx today, src/app/router.tsx
 * once that exists (AGENTS.md §1).
 */
export const dashboardRoutes: RouteObject[] = [
  {
    path: '/dashboard',
    element: <DashboardPage />
  }
];
